import React from 'react';
interface CardProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
  noPadding?: boolean;
}
export const Card: React.FC<CardProps> = ({
  children,
  title,
  subtitle,
  action,
  noPadding = false,
  className = '',
  ...props
}) => {
  return <div className={`bg-white shadow rounded-lg overflow-hidden border border-gray-200 ${className}`} {...props} data-id="element-93" data-mp="d2wvi7pia0pl">
      {(title || action) && <div className="px-4 py-5 sm:px-6 border-b border-gray-200 flex justify-between items-center bg-gray-50" data-id="element-94" data-mp="m3cxtduij1sv">
          <div data-id="element-95" data-mp="r2plu1x4eex1">
            {title && <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-96" data-mp="r2zb1nacci1o">
                {title}
              </h3>}
            {subtitle && <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-97" data-mp="2suces90kojw5">{subtitle}</p>}
          </div>
          {action && <div data-id="element-98" data-mp="2xtxdcibtyq8c">{action}</div>}
        </div>}
      <div className={noPadding ? '' : 'px-4 py-5 sm:p-6'} data-id="element-99" data-mp="2xuqnlt9zzxv8">{children}</div>
    </div>;
};